import { objectWithClassName } from "../utilities/create/jss.js";
import "../node_modules/.pnpm/postcss@8.5.8/node_modules/postcss/lib/postcss.js";
import "../node_modules/.pnpm/postcss-js@4.1.0_postcss@8.5.8/node_modules/postcss-js/index.js";
import "../node_modules/.pnpm/postcss-nesting@13.0.2_postcss@8.5.8/node_modules/postcss-nesting/dist/index.js";
import "../_virtual/index.js";
const classNamePrefix = "umd-form";
const gray = objectWithClassName({
  className: `${classNamePrefix}-gray`
});
export {
  gray
};
//# sourceMappingURL=form.js.map
